import type {AnalyticsSurveysV2DashboardActions} from 'src/action-creators/analytics/analytics-surveys-v2-dashboard';
import {
  SET_CURRENT_DASHBOARD_ID,
  RECEIVE_SURVEY_V2_TABLE_COLUMNS,
  RECEIVE_SURVEY_V2_ALL_RESPONSES_TABLE_COLUMNS,
  RECEIVE_SURVEY_V2_ALL_RECIPIENTS_TABLE_COLUMNS,
  RECEIVE_SURVEY_V2_CHART_COLUMNS,
} from 'src/action-creators/analytics/analytics-surveys-v2-dashboard';

// Simple type definition for now
type FilterColumns = {
  table_columns: Array<string>;
  entities_columns: Array<string>;
};

export type AnalyticsSurveysV2DashboardState = {
  currentDashboardID: string | null | undefined;
  tableColumns: FilterColumns | null;
  allResponsesTableColumnFilter: FilterColumns | null;
  allRecipientsTableColumnFilter: FilterColumns | null;
  chartColumnFilter: Array<string> | null;
};

const initialState: AnalyticsSurveysV2DashboardState = {
  currentDashboardID: null,
  tableColumns: null,
  allResponsesTableColumnFilter: null,
  allRecipientsTableColumnFilter: null,
  chartColumnFilter: null,
};

export default (
  state: AnalyticsSurveysV2DashboardState = initialState,
  action: AnalyticsSurveysV2DashboardActions,
): AnalyticsSurveysV2DashboardState => {
  switch (action.type) {
    case SET_CURRENT_DASHBOARD_ID: {
      return {
        ...state,
        currentDashboardID: action.payload,
      };
    }
    case RECEIVE_SURVEY_V2_TABLE_COLUMNS: {
      return {
        ...state,
        tableColumns: {
          table_columns: action.payload.columns.table_columns,
          entities_columns: action.payload.columns.entities_columns || [],
        },
      };
    }
    case RECEIVE_SURVEY_V2_ALL_RESPONSES_TABLE_COLUMNS: {
      return {
        ...state,
        allResponsesTableColumnFilter: {
          table_columns: action.payload.columns.table_columns,
          entities_columns: action.payload.columns.entities_columns || [],
        },
      };
    }
    case RECEIVE_SURVEY_V2_ALL_RECIPIENTS_TABLE_COLUMNS: {
      return {
        ...state,
        allRecipientsTableColumnFilter: {
          table_columns: action.payload.columns.table_columns,
          entities_columns: action.payload.columns.entities_columns || [],
        },
      };
    }
    case RECEIVE_SURVEY_V2_CHART_COLUMNS: {
      return {
        ...state,
        chartColumnFilter: action.payload,
      };
    }
  }
  return state;
};
